// NPM
import _ from 'lodash';
import constants from '../constants';

function formatSeatDistributionData(data, seatsPerRow) {
  const leftData = data.filter(d => d.graph_area === "left");
  const rightData = data.filter(d => d.graph_area === "right");
  
  const formattedLeftData = formatAreaData(leftData, seatsPerRow);
  const formattedRightData = formatAreaData(rightData, seatsPerRow);

  const totalLeftRows = _.sumBy(formattedLeftData, "numRows");
  const totalRightRows = _.sumBy(formattedRightData, "numRows");

  let sideMaxSectionGap = 0;

  return {
    leftData: formattedLeftData,
    rightData: formattedRightData
  }
}

function formatAreaData(areaData, seatsPerRow) {
  const areaGroups = _
  .chain(areaData)
  .sortBy("graph_area_order")
  .groupBy("graph_area_order")
  .map(g => g)
  .value();

  // Create arrays for each group
  return _.map(areaGroups, group => {

    // Process each of the subGroups in the group
    let partySubGroups = _
      .chain(group)
      .sortBy(subGroup => subGroup.graph_area_sub_order)
      .flatMap(subGroup => {
        // Create a range for each seat in the subGroup
        let subGroupRange = _.range(parseInt(subGroup.seat_count));

        // Loop over the range and replace it with values for each seat
        return _.map(subGroupRange, index => {
          return {
            index,
            party: subGroup.party
          }
        })  
      })
      .value()

      // Split all the seats into rows
    return _.chunk(partySubGroups, seatsPerRow);
  });
}

export default {
  formatSeatDistributionData
}